export default __webpack_public_path__ + "static/media/815.3ea417cb.png";